export function shouldRequireSignature(flowType) {
  return flowType !== "single-person";
}

export function buildContractPayload(formData, flowType = "seller") {
  const isSinglePersonMode = flowType === "single-person";
  const sellerName =
    `${formData.firstName || ""} ${formData.lastName || ""}`.trim();

  return {
    createdFor: "seller",
    ...(isSinglePersonMode ? {} : { sendRequestFor: formData.buyerMobile }),
    seller: {
      name: sellerName,
      fatherName: formData.fatherName,
      idNumber: formData.idNumber,
      nationalCode: formData.nationalCode,
      idIssuePlace: formData.idIssuePlace,
      birthDate: formData.birthDate,
      address: formData.address,
      phone: formData.phone,
      mobile: formData.mobile,
      w: formData.signature || null,
    },
    buyer: isSinglePersonMode
      ? {
          firstName: formData.buyerFirstName || "",
          lastName: formData.buyerLastName || "",
          fatherName: formData.buyerFatherName || "",
          idNumber: formData.buyerIdNumber || "",
          nationalCode: formData.buyerNationalCode || "",
          idIssuePlace: formData.buyerIdIssuePlace || "",
          birthDate: formData.buyerBirthDate || "",
          address: formData.buyerAddress || "",
          phone: formData.buyerPhone || "",
          mobile: formData.buyerMobile || "",
          signature: formData.buyerSignature || null,
        }
      : null,
    vehicle: {
      name: formData.vehicleName,
      model: formData.vehicleModel,
      color: formData.vehicleColor,
      chassisNumber: formData.chassisNumber,
      engineNumber: formData.engineNumber,
      plateNumber: formData.plateNumber,
    },
    deal: {
      amountRial: formData.amountRial,
      amountToman: formData.amountToman,
      paymentTerms: formData.paymentTerms,
      description: formData.dealDescription,
    },
    transfer: {
      transferFeeBy: formData.transferFeeBy,
      plateFeeBy: formData.plateFeeBy,
      notaryDate: formData.notaryDate,
      notaryNumber: formData.notaryNumber,
      notaryAddress: formData.notaryAddress,
    },
    delivery: {
      date: formData.deliveryDate,
      time: formData.deliveryTime,
      condition: formData.vehicleCondition,
      mileage: formData.vehicleMileage,
    },
    penalty: {
      description: formData.penaltyDescription,
    },
    contractNumber: `K24-${Date.now()}`,
    status: isSinglePersonMode ? "completed" : "pending_buyer",
    flowType,
  };
}
